import { WEB_COMPONENT_MOBILE_SECURITY_APP } from '../../webcomponents.constants';
import { MobileSecurityCompanyGridWebComponent } from './component/MobileSecurityCompanyGridWebComponent';

export { MobileSecurityCompanyGridWebComponent };

window.customElements.define(WEB_COMPONENT_MOBILE_SECURITY_APP, MobileSecurityCompanyGridWebComponent);
